export const translations = {
  en: {
    // Input & Messages
    inputPlaceholder: "What's on your mind?",
    thinking: "Typing",
    
    // Settings Panel
    settings: "Settings",
    darkMode: "Dark Mode",
    expertiseLevel: "Expertise Level",
    language: "Language",
    chatColors: "Chat Colors",
    userMsgBg: "User Message Background",
    userMsgText: "User Message Text",
    aiMsgBg: "AI Message Background",
    aiMsgText: "AI Message Text",
    iconColor: "Icon Color",
    resetColors: "Reset Colors",
    generateImage: "Generate Image",
    exportChat: "Export Chat as PDF",

    // Expertise Levels
    novice: "Novice",
    student: "Student",
    professional: "Professional",
    researcher: "Researcher",

    // Chat Panel
    newChat: "New Chat",
    previousChats: "Previous Chats",
    deleteChat: "Delete Chat",

    // Web Search
    webSearchEnabled: "web search enabled",

    // Error Messages
    errorMessage: "Sorry, both AI models failed to process your request. Please try again later.",

    // Chat Panel
    searchChats: "Search chats",

    // Conversation Mode
    conversationMode: "Conversation Mode",
    pressStartToTalk: "Press Start to begin conversation",
    listening: "Listening...",
    thinking: "Thinking...",
    speaking: "Speaking...",
    startConversation: "Start Conversation",
    stopConversation: "Stop Conversation"
  },
  es: {
    inputPlaceholder: "¿Qué tienes en mente?",
    thinking: "Escribiendo",
    settings: "Ajustes",
    darkMode: "Modo Oscuro",
    expertiseLevel: "Nivel de Experiencia",
    language: "Idioma",
    chatColors: "Colores del Chat",
    userMsgBg: "Fondo Mensaje Usuario",
    userMsgText: "Texto Mensaje Usuario",
    aiMsgBg: "Fondo Mensaje IA",
    aiMsgText: "Texto Mensaje IA",
    iconColor: "Color del Icono",
    resetColors: "Restablecer Colores",
    generateImage: "Generar Imagen",
    exportChat: "Exportar Chat como PDF",
    novice: "Principiante",
    student: "Estudiante",
    professional: "Profesional",
    researcher: "Investigador",
    newChat: "Nuevo Chat",
    previousChats: "Chats Anteriores",
    deleteChat: "Eliminar Chat",
    webSearchEnabled: "búsqueda web activada",
    errorMessage: "Lo sentimos, ambos modelos de IA fallaron al procesar tu solicitud. Por favor, inténtalo de nuevo más tarde.",
    searchChats: "Buscar chats"
  },
  zh: {
    inputPlaceholder: "你在想什么？",
    thinking: "正在输入",
    settings: "设置",
    darkMode: "深色模式",
    expertiseLevel: "专业水平",
    language: "语言",
    chatColors: "聊天颜色",
    userMsgBg: "用户消息背景",
    userMsgText: "用户消息文本",
    aiMsgBg: "AI消息背景",
    aiMsgText: "AI消息文本",
    iconColor: "图标颜色",
    resetColors: "重置颜色",
    generateImage: "生成图片",
    exportChat: "导出聊天为PDF",
    novice: "新手",
    student: "学生",
    professional: "专业人士",
    researcher: "研究员",
    newChat: "新对话",
    previousChats: "历史对话",
    deleteChat: "删除对话",
    webSearchEnabled: "网络搜索已启用",
    errorMessage: "抱歉，两个AI模型都无法处理您的请求。请稍后再试。",
    searchChats: "搜索对话"
  },
  hi: {
    inputPlaceholder: "आप क्या सोच रहे हैं?",
    thinking: "टाइप कर रहा है",
    settings: "सेटिंग्स",
    darkMode: "डार्क मोड",
    expertiseLevel: "विशेषज्ञता स्तर",
    language: "भाषा",
    chatColors: "चैट रंग",
    userMsgBg: "उपयोगकर्ता संदेश पृष्ठभूमि",
    userMsgText: "उपयोगकर्ता संदेश टेक्स्ट",
    aiMsgBg: "AI संदेश पृष्ठभूमि",
    aiMsgText: "AI संदेश टेक्स्ट",
    iconColor: "आइकन का रंग",
    resetColors: "रंग रीसेट करें",
    generateImage: "छवि बनाएं",
    exportChat: "चैट को PDF के रूप में निर्यात करें",
    novice: "नौसिखिया",
    student: "छात्र",
    professional: "पेशेवर",
    researcher: "शोधकर्ता",
    newChat: "नई चैट",
    previousChats: "पिछली चैट",
    deleteChat: "चैट हटाएं",
    webSearchEnabled: "वेब खोज सक्षम",
    errorMessage: "क्षमा करें, दोनी AI मॉडल आपके अनुरोध को संसाधित करने में विफल रहे। कृपया बाद में पुनः प्रयास करें।",
    searchChats: "चैट खोजें"
  },
  fr: {
    inputPlaceholder: "Qu'avez-vous à l'esprit ?",
    thinking: "En train d'écrire",
    settings: "Paramètres",
    darkMode: "Mode Sombre",
    expertiseLevel: "Niveau d'Expertise",
    language: "Langue",
    chatColors: "Couleurs du Chat",
    userMsgBg: "Fond Message Utilisateur",
    userMsgText: "Texte Message Utilisateur",
    aiMsgBg: "Fond Message IA",
    aiMsgText: "Texte Message IA",
    iconColor: "Couleur de l'icône",
    resetColors: "Réinitialiser les Couleurs",
    generateImage: "Générer une Image",
    exportChat: "Exporter le Chat en PDF",
    novice: "Débutant",
    student: "Étudiant",
    professional: "Professionnel",
    researcher: "Chercheur",
    newChat: "Nouvelle Conversation",
    previousChats: "Conversations Précédentes",
    deleteChat: "Supprimer la Conversation",
    webSearchEnabled: "recherche web activée",
    errorMessage: "Désolé, les deux modèles d'IA n'ont pas pu traiter votre demande. Veuillez réessayer plus tard.",
    searchChats: "Rechercher des conversations"
  },
  pt: {
    inputPlaceholder: "O que você está pensando?",
    thinking: "Digitando",
    settings: "Configurações",
    darkMode: "Modo Escuro",
    expertiseLevel: "Nível de Especialização",
    language: "Idioma",
    chatColors: "Cores do Chat",
    userMsgBg: "Fundo Mensagem Usuário",
    userMsgText: "Texto Mensagem Usuário",
    aiMsgBg: "Fundo Mensagem IA",
    aiMsgText: "Texto Mensagem IA",
    iconColor: "Cor do Ícone",
    resetColors: "Redefinir Cores",
    generateImage: "Gerar Imagem",
    exportChat: "Exportar Chat como PDF",
    novice: "Iniciante",
    student: "Estudante",
    professional: "Profissional",
    researcher: "Pesquisador",
    newChat: "Nova Conversa",
    previousChats: "Conversas Anteriores",
    deleteChat: "Excluir Conversa",
    webSearchEnabled: "busca web ativada",
    errorMessage: "Desculpe, ambos os modelos de IA falharam ao processar sua solicitação. Por favor, tente novamente mais tarde.",
    searchChats: "Pesquisar conversas"
  },
  ru: {
    inputPlaceholder: "О чём вы думаете?",
    thinking: "Печатает",
    settings: "Настройки",
    darkMode: "Тёмный Режим",
    expertiseLevel: "Уровень Экспертизы",
    language: "Язык",
    chatColors: "Цвета Чата",
    userMsgBg: "Фон Сообщения Пользователя",
    userMsgText: "Текст Сообщения Пользователя",
    aiMsgBg: "Фон Сообщения ИИ",
    aiMsgText: "Текст Сообщения ИИ",
    iconColor: "Цвет Иконки",
    resetColors: "Сбросить Цвета",
    generateImage: "Создать Изображение",
    exportChat: "Экспортировать Чат в PDF",
    novice: "Новичок",
    student: "Студент",
    professional: "Профессионал",
    researcher: "Исследователь",
    newChat: "Новый Чат",
    previousChats: "Предыдущие Чаты",
    deleteChat: "Удалить Чат",
    webSearchEnabled: "веб-поиск включен",
    errorMessage: "Извините, оба ИИ-модели не смогли обработать ваш запрос. Пожалуйста, попробуйте позже.",
    searchChats: "Поиск чатов"
  },
  ko: {
    inputPlaceholder: "무엇을 생각하고 계신가요?",
    thinking: "입력 중",
    settings: "설정",
    darkMode: "다크 모드",
    expertiseLevel: "전문성 수준",
    language: "언어",
    chatColors: "채팅 색상",
    userMsgBg: "사용자 메시지 배경",
    userMsgText: "사용자 메시지 텍스트",
    aiMsgBg: "AI 메시지 배경",
    aiMsgText: "AI 메시지 텍스트",
    iconColor: "아이콘 색상",
    resetColors: "색상 초기화",
    generateImage: "이미지 생성",
    exportChat: "채팅을 PDF로 내보내기",
    novice: "초보자",
    student: "학생",
    professional: "전문가",
    researcher: "연구원",
    newChat: "새 대화",
    previousChats: "이전 대화",
    deleteChat: "대화 삭제",
    webSearchEnabled: "웹 검색 활성화됨",
    errorMessage: "죄송합니다. 두 AI 모델 모두 요청을 처리하지 못했습니다. 나중에 다시 시도해 주세요.",
    searchChats: "대화 검색"
  },
  ja: {
    inputPlaceholder: "何を考えていますか？",
    thinking: "入力中",
    settings: "設定",
    darkMode: "ダークモード",
    expertiseLevel: "専門レベル",
    language: "言語",
    chatColors: "チャットの色",
    userMsgBg: "ユーザーメッセージの背景",
    userMsgText: "ユーザーメッセージのテキスト",
    aiMsgBg: "AIメッセージの背景",
    aiMsgText: "AIメッセージのテキスト",
    iconColor: "アイコンの色",
    resetColors: "色をリセット",
    generateImage: "画像を生成",
    exportChat: "チャットをPDFで出力",
    novice: "初心者",
    student: "学生",
    professional: "専門家",
    researcher: "研究者",
    newChat: "新しい会話",
    previousChats: "過去の会話",
    deleteChat: "会話を削除",
    webSearchEnabled: "ウェブ検索が有効",
    errorMessage: "申し訳ありません。両方のAIモデルがリクエストを処理できませんでした。後でもう一度お試しください。",
    searchChats: "会話を検索"
  },
  de: {
    inputPlaceholder: "Was haben Sie auf dem Herzen?",
    thinking: "Schreibt",
    settings: "Einstellungen",
    darkMode: "Dunkelmodus",
    expertiseLevel: "Expertiseniveau",
    language: "Sprache",
    chatColors: "Chat-Farben",
    userMsgBg: "Benutzer-Nachricht Hintergrund",
    userMsgText: "Benutzer-Nachricht Text",
    aiMsgBg: "KI-Nachricht Hintergrund",
    aiMsgText: "KI-Nachricht Text",
    iconColor: "Symbolfarbe",
    resetColors: "Farben zurücksetzen",
    generateImage: "Bild generieren",
    exportChat: "Chat als PDF exportieren",
    novice: "Anfänger",
    student: "Student",
    professional: "Profi",
    researcher: "Forscher",
    newChat: "Neuer Chat",
    previousChats: "Vorherige Chats",
    deleteChat: "Chat löschen",
    webSearchEnabled: "Websuche aktiviert",
    errorMessage: "Entschuldigung, beide KI-Modelle konnten Ihre Anfrage nicht verarbeiten. Bitte versuchen Sie es später erneut.",
    searchChats: "Chats durchsuchen"
  },
  it: {
    inputPlaceholder: "A cosa stai pensando?",
    thinking: "Scrivendo",
    settings: "Impostazioni",
    darkMode: "Modalità Scura",
    expertiseLevel: "Livello di Competenza",
    language: "Lingua",
    chatColors: "Colori Chat",
    userMsgBg: "Sfondo Messaggio Utente",
    userMsgText: "Testo Messaggio Utente",
    aiMsgBg: "Sfondo Messaggio IA",
    aiMsgText: "Testo Messaggio IA",
    iconColor: "Colore dell'icona",
    resetColors: "Reimposta Colori",
    generateImage: "Genera Immagine",
    exportChat: "Esporta Chat come PDF",
    novice: "Principiante",
    student: "Studente",
    professional: "Professionista",
    researcher: "Ricercatore",
    newChat: "Nuova Chat",
    previousChats: "Chat Precedenti",
    deleteChat: "Elimina Chat",
    webSearchEnabled: "ricerca web attivata",
    errorMessage: "Spiacenti, entrambi i modelli di IA non sono riusciti a elaborare la tua richiesta. Per favore riprova più tardi.",
    searchChats: "Cercare conversazioni"
  }
  // Add other languages similarly...
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations.en[key];
}; 